import { ErrorDetailsModel } from "../../models/ErrorDetailsModel";
import { checkForSeasonTicketCrmIdNotAvailableError, checkForParkingRightsAlreadyLinkedToALicensePlate, checkForSeasonTicketCrmIdNotValidError } from "../../utils";
import { toastActions } from "./toast.actions";

export const checkForCrmIdOrLinkedAccessDevice = (
    dispatch: (action: any) => void,
    error: ErrorDetailsModel | null,
): void => {
    if (checkForSeasonTicketCrmIdNotAvailableError(error)) {
        dispatch(toastActions.error(({
            content: {
                key: "parkingRights.seasonTicketOwnerCrmId.not_available",
            },
        })));
    } else if (checkForSeasonTicketCrmIdNotValidError(error)) {
        dispatch(toastActions.error(({
            content: {
                key: "errors.invalidSeasonTicketCrmId",
            },
        })));
    } else if (checkForParkingRightsAlreadyLinkedToALicensePlate(error)) {
        dispatch(toastActions.error(({
            content: {
                key: "parkingRights.accessDevice.alreadyLinked",
            },
        })));
    }
};
